/* Model */
class WGLNIntegrationLogModel extends App.Models.BaseModel {
  modelUrl = 'WGLNIntegrationLog';
}

App.Models.WGLNIntegrationLog = WGLNIntegrationLogModel;

/* Collection */
class WGLNIntegrationLogCollection extends App.Collections.BaseCollection {
  url = 'WGLNIntegrationLog';
  model = App.Models.WGLNIntegrationLog;
}

App.Collections.WGLNIntegrationLogs = WGLNIntegrationLogCollection;

/* Router */
class WGLNIntegrationLogRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'WGLNIntegrationLog';
    const model = App.Models.WGLNIntegrationLog;
    const collectionClass = App.Collections.WGLNIntegrationLogs;

    super(entityName, model, collectionClass);
  }

  removeSaveGridLayoutButton = function () {
    const tabId = this.getTabIdSelector();
    const saveGridButton = document.querySelector(`#${tabId} .saveLayout.gridActionDiv`);

    saveGridButton && saveGridButton.remove();
  };


  makeListScreen = (layout) => {
    this.collectionFilter = Monet.Grid.Utils.getFilterToSearch(this.entityName);
    this.collectionCriteria = null;

    if (layout) {
      const tabIdSelector = this.getTabIdSelector();

      if (!this.permissionDenied) {
        Monet.Form.checkFormTemplate(tabIdSelector);
        this.generateDatamapper(this.entityName, layout);

        const form = this.renderMonetForm(this.entityName, layout, tabIdSelector);

        form.initializeGrid(this.customGridActions);

        this.removeSaveGridLayoutButton();

        this.local_collection = this.collection;
        this.collectionCriteria = this.getProjectionBasedOnIndex();

        this?.beforeList();

        this.executeCustomFilter(this.entityName);
      }
    } else {
        //Sem informação de layout, verifique se o servidor está funcionando corretamente
        new Greenmile.Components.AlertModal("Greenmile.error.layout.notFound")
            .show();
    }

    return this;
  };
}

App.Routers.WGLNIntegrationLog = WGLNIntegrationLogRouter;
